<input
  #fileInput
  class="file-upload__input"
  type="file"
  tabindex="-1"
  aria-hidden="true"
  [accept]="accept()"
  [disabled]="disabled()"
  (change)="onInputChange($event)"
/>

@switch (state()) {
  @case ('attached') {
    <div class="file-upload__file">
      <app-icon class="file-upload__icon file-upload__icon--success" name="check" />
      <p class="file-upload__file-name">{{ fileName() }}</p>
      <p class="file-upload__file-size">{{ fileSize() }}</p>
      <button
        class="file-upload__remove"
        type="button"
        aria-label="Remove file"
        (click)="remove($event)"
      >
        <app-icon class="file-upload__icon" name="close" />
      </button>
    </div>
    <p class="file-upload__status">Attached</p>
  }

  @case ('uploading') {
    <div class="file-upload__file">
      <app-icon class="file-upload__icon" name="file" />
      <p class="file-upload__file-name">{{ fileName() }}</p>
      <p class="file-upload__file-size">{{ fileSize() }}</p>
      <button
        class="file-upload__remove"
        type="button"
        aria-label="Cancel upload"
        (click)="remove($event)"
      >
        <app-icon class="file-upload__icon" name="close" />
      </button>
    </div>
    <p class="file-upload__status">Uploading — {{ progressValue() }}%</p>
  }

  @case ('error') {
    <div class="file-upload__file file-upload__file--error">
      <app-icon class="file-upload__icon file-upload__icon--error" name="alert-circle" />
      <button
        class="file-upload__remove"
        type="button"
        aria-label="Dismiss"
        (click)="remove($event)"
      >
        <app-icon class="file-upload__icon" name="close" />
      </button>
    </div>
    <button class="file-upload__retry" type="button" (click)="open()">Pick a different file</button>
  }

  @default {
    <button class="file-upload__open" type="button" [disabled]="disabled()" (click)="open()">
      <span class="file-upload__title">Choose a file, or drag one here</span>
      <span class="file-upload__hint">
        <span>{{ description() }}</span>
        <span>{{ formatsHint() }}</span>
      </span>
    </button>
  }
}
